import { Component, OnInit } from '@angular/core';
import { OrderService, ProductService, AuthenticationService } from '@app/core';
import { Order } from '@core/model/order.model';
import { Client } from '@app/core/model/client.model';
import { CurrencyPipe } from '@angular/common';
import { ClientService } from '@app/core/service/client.service';
import { CreateClientComponent } from '@app/dashboard/client/create-cliente/create-cliente.component';
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalOptions
} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { finalize } from 'rxjs/operators';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Product } from '@app/core/model/product.model';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ProformaService } from '@app/core/service/proforma.service';

@Component({
  selector: 'app-createproforma',
  templateUrl: './createproforma.component.html',
  styleUrls: ['./createproforma.component.css']
})
export class CreateproformaComponent implements OnInit {

  orders: Order[];
  selectedValue: any;
  nit: string;
  direccion: string;
  clientes: Client[];
  products: Product[];

  color:string;

  title = 'ng-bootstrap-modal-demo';
  closeResult: string;
  modalOptions: NgbModalOptions;

  form: FormGroup;
  value: boolean;
  totalSum = 0;
  myFormValueChanges$: any;

  fecha_orden: string;
  fecha_entrega: string;
  currentUserSubscription: Subscription;

  currentUser: any;
  userid: string;
  stock: string;
  cantPedidos: string;
  cancelacion = [
    {
      name: 'Contado',
      rnNo: 1
    },
    {
      name: 'Credito',
      rnNo: 2
    }
  ];
  selected: any;
  isLoading = false;
  constructor(
    private orderService: OrderService,
    private proformaService:ProformaService,
    private router: Router,
    private clienteService: ClientService,
    private productService: ProductService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private currencyPipe: CurrencyPipe,
    private authService: AuthenticationService
  ) {
    this.currentUserSubscription = this.authService.currentUser.subscribe(
      user => {
        this.currentUser = user.data.user.id;
        //  console.log(this.currentUser.data.user);
        this.userid = this.currentUser;
      }
    );

    this.fecha_orden = new Date().toISOString().substring(0, 10);
    this.fecha_entrega = new Date().toISOString().substring(0, 10);
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop'
    };

    this.form = this.fb.group({
      credentials: this.fb.array([], Validators.required),
      pago: ['', [Validators.required]]
    });

    this.myFormValueChanges$ = this.form.controls['credentials'].valueChanges;
    this.myFormValueChanges$.subscribe((units: any) =>
      this.updateTotalUnitPrice(units)
    );
    this.listProducts();
  }

  ngOnInit() {
    this.listarClientes();
  }
  public onStateChanged(value: boolean) {
    this.value = value;
  }

  get formData() {
    return <FormArray>this.form.get('credentials');
  }

  nuevoProducto() {
    const numberPatern = '^[0-9.,]+$';
    const creds = this.form.controls.credentials as FormArray;
    creds.push(
      this.fb.group({
        producto: '',
        stock: [{ value: '', disabled: true }],
        unidad: [{ value: '', disabled: true }],
        cantidad: ['', [Validators.required]],
        precio: ['', [Validators.required]],
        precio2: ['', [Validators.required]],
        totalUnitPrice: [{ value: '', disabled: true }]
      })
    );
  }
  eliminarProducto(index: any) {
    const control = <FormArray>this.form.controls.credentials;
    control.removeAt(index);
  }

  updateTotalUnitPrice(units: any) {
    // get our units group controll
    const control = <FormArray>this.form.controls['credentials'];
    // before recount total price need to be reset.
    this.totalSum = 0;

    for (const i in units) {
      const totalUnitPrice = units[i].cantidad * units[i].precio;
      // now format total price with angular currency pipe
      const totalUnitPriceFormatted = this.currencyPipe.transform(
        totalUnitPrice,
        'BOB',
        'symbol-narrow',
        '1.2-2'
      );

      
      // update total sum field on unit and do not emit event myFormValueChanges$ in this case on units
      control
        .at(+i)
        .get('totalUnitPrice')
        .setValue(totalUnitPrice.toFixed(2), {
          onlySelf: true,
          emitEvent: false
        });
      // update total price for all units
      this.totalSum += totalUnitPrice;
    }
  }

  listProducts() {
    this.productService.getProductosExistencia().subscribe(
      data => {
        this.products = data;
        console.log(data);
      },
      error1 => {
        console.log(error1.error);
      }
    );
  }

  save(model: any) {
    // e.preventDefault();
    console.log(JSON.stringify(model));
    const data = {
      cliente_id: this.selectedValue.cliente_id,
      fecha_orden: this.fecha_orden,
      fecha_entrega: this.fecha_entrega,
      user_id: this.userid,
      productos: this.form.get('credentials').value,
      tipo_pago: this.form.get('pago').value
    };

    this.isLoading = true;

    this.proformaService
      .create(data)
      .pipe(
        finalize(() => {
          this.form.markAsPristine();
          this.isLoading = false;
        })
      )
      .subscribe(
        data1 => {
          Swal.fire(data1);
          this.form.reset();
          this.router.navigate(['/dashboard/proforma-list']);
        },
        error1 => {
          Swal.fire(error1.error);
        }
      );
  }

  getSelectedOptionText(event: any) {
    console.log(event);
    // this.resetPurchase();
    // this.showDiv = null;
    this.nit = this.selectedValue.ci_nit;
    this.direccion = this.selectedValue.direccion;
    // this.addressCustomer = event.address;
  }

  getSelectedProduct(event: Product, i: number) {
    // alert(event);

    console.log('Producto Changed: ' + event.producto_id);
    // console.log(JSON.stringify(event));
    // this.resetPurchase();
    // this.showDiv = null;
    console.log(i);

    this.patchValues(event.producto_id, i);
    // this.addressCustomer = event.address;
  }

  patchValues(id: number, i: number) {
    const x = (<FormArray>this.form.controls['credentials']).at(i);
    //  this.stock = this.products[id - 1].cantidad;
    // this.cantPedidos = this.products[id - 1].cantidad_pedidos;
    const objeto = this.products.filter(y => y.producto_id === id)[0];
    console.log(objeto);
    x.patchValue({
      stock: parseInt(objeto.cantidad),// - parseInt(objeto.cantidad_pedidos),
      unidad: objeto.unidad,
      precio: objeto.precio_venta,
      precio2: objeto.costo_prom,
      cantidad: 0
    });
  }

  listarClientes() {
    this.clienteService.getClientesHabilitados().subscribe(
      data => {
        this.clientes = data;
        this.selectedValue = data[0];
        this.nit = data[0].ci_nit;
        this.direccion = data[0].direccion;

        console.log(this.selectedValue.cliente_id + '2');
      },
      error => {
        console.log(error.error);
      }
    );
  }

  clienteModal(content: any) {
    this.modalService
      .open(CreateClientComponent, this.modalOptions)
      .result.then(
        result => {
          this.closeResult = `Closed with: ${result}`;
          this.listarClientes();
        },
        reason => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );

    // this.modal.load({
    //  id: 'my-modal',
    //  component: CreateClientComponent
    // });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      this.listarClientes();
      return `with: ${reason}`;
    }
  }

}
